import * as CryptoJS from 'crypto-js';

export class CryptoService {

  private static readonly encryptionKey = 'yuteam-enc-key-xy200';

  static Encrypt(value: any): string {
    if(value){
      const stringified = JSON.stringify(value);
      return CryptoJS.AES.encrypt(stringified, this.encryptionKey).toString();
    }
  }

  static Decrypt<T = any>(encrypted: string): T | null {
    if(encrypted){
      try {
        const bytes = CryptoJS.AES.decrypt(encrypted, this.encryptionKey);
        const decrypted = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(decrypted);
      } catch (e) {
        console.error('Decryption failed:', e);
        return null;
      }
    }
  }
}
